import type { ActivityPeriod } from "../schemas/activity";
import {
	activityEventSchema,
	activityRollupSchema,
	activitySeriesSchema,
} from "../schemas/activity";
import { fetchApi, paginatedSchema } from "./internal";

export const activity = {
	events: (limit = 20, offset = 0) =>
		fetchApi(
			`/admin/activities/events?limit=${limit}&offset=${offset}`,
			paginatedSchema(activityEventSchema),
		),
	rollup: (period: ActivityPeriod) =>
		fetchApi(`/admin/activities?period=${period}`, activityRollupSchema),
	series: (days: number) => fetchApi(`/admin/activities/series?days=${days}`, activitySeriesSchema),
};
